import { useTranslation } from "react-i18next";

import { Flex, Row, Select, Space, Button, DatePicker, ConfigProvider } from "antd";
import EmployeeSalaryAccumulateTable from "components/table/EmployeeSalaryAccumulateTable";
import { ReactComponent as HistoryIcon } from "../../../assets/icon/historyIcon.svg";
import { ReactComponent as EyeHideIcon } from "../../../assets/icon/eyeClose.svg";
import { ReactComponent as EyeIcon } from "../../../assets/icon/eyeIcon.svg";
import { useState } from "react";
import ModalSalaryAccumulate from "components/elements/Modal/ModalSalaryAccumulate";
import dayjs from "dayjs";
import { FormDatePicker } from "components/form/FormProvide";

function EmployeeSalaryAccumulate({
  pagination = {},
  isLoading = false,
  selectedYear = null,
  accumulateList = [],
  isModalOpen = false,
  setIsModalOpen = () => { },
  onEdit = () => { },
  onDelete = () => { },
  onChange = () => { },
  onFilter = () => { },
  onYearChange = () => { },
  onCancel = () => { },
  employeeYearAccumulate = [],
  onSubmit = () => { },
  getModal = () => { }
}) {
  const { t, i18n } = useTranslation();
  const [isAmountVisible, setIsAmountVisible] = useState(false);

  const handleToggleVisibility = () => {
    setIsAmountVisible(prevState => !prevState);
  };

  return (
    <>
      {getModal}
      <Space style={{ width: "100%" }} size={24} direction="vertical">
        <Row justify="end" align={"middle"} style={{ gap: "10px" }}>
          {/* <Select
            value={selectedYear}
            defaultValue={selectedYear}
            onChange={onYearChange}
            style={{ width: 120, height: "44px" }}
            options={[]}
            size="large"
          /> */}

          <FormDatePicker
            picker="year"
            dateFormat={"YYYY"}
            style={{ width: 100, height: "44px", borderRadius: "8px" }}
            defaultValue={selectedYear ? dayjs().year(selectedYear) : dayjs().year()}
            onChange={onYearChange}
          />

          <Button style={{ width: "max-content", height: "44px", borderRadius: "8px", padding: "10px 16px" }}>
            <Flex align="center" justify="center" gap={8}>
              <HistoryIcon />
              <span style={{ color: "#344054" }}>{t("becash.label.history")}</span>
            </Flex>
          </Button>

          <Button style={{ width: "max-content", height: "44px", borderRadius: "8px", padding: "10px 16px" }}
            icon={isAmountVisible ? <EyeHideIcon /> : <EyeIcon />}
            onClick={handleToggleVisibility}
          />
        </Row>
        <EmployeeSalaryAccumulateTable
          isLoading={isLoading}
          dataSource={accumulateList}
          pagination={pagination}
          onEdit={onEdit}
          onDelete={onDelete}
          onChange={onChange}
          isAmountVisible={isAmountVisible}
          employeeYearAccumulate={employeeYearAccumulate}
        />
      </Space>
    </>
  );
}

export default EmployeeSalaryAccumulate;
